import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { PageHyundaiPromiseVM } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'HyundaiPromiseVM',
    events: {
        'Load Hyundai Promise VM': emptyProps(),
        'Load Hyundai Promise VM Success': props<{ content: PageHyundaiPromiseVM }>(),
        'Load Hyundai Promise VM Failure': props<{ error: string }>(),
    },
});
